import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import PatternImg from "images/png/rated-playlist-background-pattern.png";
import SpotifyCanvasTool from "./spotifyCanvas";

const PageHeader = () => {
  return (
    <div>
      <Header>
        <BgHeader src={PatternImg} alt="bg-pattern" />
        <HeaderPart>
          <Typography
            color={Colors.white100}
            size="4xl"
            weight="bold"
            m_size="xl"
            mb="3.2"
            m_mb="1.9"
          >
            Spotify Canvas Generator
          </Typography>
          <HeaderText>
            <Typography
              color={Colors.white100}
              size="6rem"
              weight="bold"
              m_size="4xl"
              mb="1.6"
            >
              Bring Your Music to Life!
            </Typography>
          </HeaderText>
          <Typography size="2xl" color={Colors.grey500} mb="3.2">
            Enhance your{" "}
            <span style={{ color: Colors.grey100, fontWeight: 500 }}>
              Spotify
            </span>{" "}
            releases with{" "}
            <span style={{ color: Colors.grey100, fontWeight: 500 }}>
              eye-catching looping visuals.
            </span>{" "}
            Engage your listeners and make your music stand out with free custom{" "}
            <span style={{ color: Colors.grey100, fontWeight: 500 }}>
              canvas animations.
            </span>
          </Typography>
          {/* 
          <PrimaryButton
            onClick={() => {}}
            text="Generate a canvas"
            inset
            sparkle
            // icon={<Arrow />}
            iconPosition="right"
            fitContent
            iconSize="2"
          /> */}
        </HeaderPart>
        <HeaderPart>
          <SpotifyCanvasTool />
        </HeaderPart>
      </Header>
    </div>
  );
};

export default PageHeader;

const Header = styled.section`
  display: grid;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: 40% 50%;
  padding-bottom: 18rem;
  position: relative;

  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    padding-bottom: 1rem;
  }
`;

const HeaderText = styled.div`
  width: 80%;
`;

const BgHeader = styled.img`
  position: absolute;
  width: 100%;
  top: 18%;
  @media only screen and (max-width: 769px) {
    height: 100%;
    width: 350%;
    top: 0%;
    left: -10%;
  }
`;

const HeaderPart = styled.div`
  position: relative;
`;
